import React, { useEffect } from 'react'
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import useTheme from '../../MobileAppUrl/UseTheme';
import useDarkTheme from '../../MobileAppUrl/UseDarkTheme';
import GoBack from '../BackButton/GoBack';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy(props: any) {

    const { t } = useTranslation();
    const { theme, toggleTheme } = useTheme();
    const { darktheme, toggleDarkTheme } = useDarkTheme();

    useEffect(() => {
        const { theme } = props.match.params;

        if (theme === undefined) {
            localStorage.removeItem("theme");
            return;
        }
        if (theme === "night") {
            toggleDarkTheme();
            return;
        }
        if (theme === "day") {
            toggleTheme();
            return;
        }
    }, [props.match.params]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <section>
                <div className="container">
                    <div className='about-us position-relative pricavy-policy-container'>
                        <div className="back-btn-position web-backbtn">
                            <GoBack />
                        </div>
                        <h2 className='about-title'> {t('PRIVACY_TITLE')} </h2>

                        <section id="section-1" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC1_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC1_P1')}
                            </p>
                        </section>

                        {/* Section 2: Data controller */}
                        <section id="section-2" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC2_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC2_CONTACT_INTRO')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>
                                    {t('PRIVACY_SEC2_CONTACT_POSTAL_LABEL')} Commune de Dely Brahim, cité Bois des Cars 02 N°213 Alger, Algeria.
          </li>
                                <li>
                                    {t('PRIVACY_SEC2_CONTACT_EMAIL_LABEL')} <a href="mailto:privacy@azadea.com">privacy@azadea.com</a>
                                </li>
                            </ol>
                        </section>

                        {/* Section 3: Information we collect */}
                        <section id="section-3" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC3_TITLE')}</h2>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC3_LI1')}</li>
                                <li>{t('PRIVACY_SEC3_LI2')}</li>
                                <li>{t('PRIVACY_SEC3_LI3')}</li>
                                <li>{t('PRIVACY_SEC3_LI4')}</li>
                            </ol>
                        </section>

                        {/* Section 4: How we collect information */}
                        <section id="section-4" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC4_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC4_P1')}
                            </p>
                        </section>

                        {/* Section 5: How we use information */}
                        <section id="section-5" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC5_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC5_P1')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC5_LI1')}</li>
                                <li>{t('PRIVACY_SEC5_LI2')}</li>
                                <li>{t('PRIVACY_SEC5_LI3')}</li>
                                <li>{t('PRIVACY_SEC5_LI4')}</li>
                                <li>{t('PRIVACY_SEC5_LI5')}</li>
                                <li>{t('PRIVACY_SEC5_LI6')}</li>
                            </ol>
                        </section>

                        {/* Section 6: Third parties we share your personal data with */}
                        <section id="section-6" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC6_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC6_P1')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC6_STEPS_INTRO')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC6_STEPS_LI1')}</li>
                                <li>{t('PRIVACY_SEC6_STEPS_LI2')}</li>
                                <li>{t('PRIVACY_SEC6_STEPS_LI3')}</li>
                                <li>{t('PRIVACY_SEC6_STEPS_LI4')}</li>
                            </ol>
                            <p>
                                {t('PRIVACY_SEC6_EXAMPLES_INTRO')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI1')}</li>
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI2')}</li>
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI3')}</li>
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI4')}</li>
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI5')}</li>
                                <li>{t('PRIVACY_SEC6_EXAMPLES_LI6')}</li>
                            </ol>
                            <p>
                                {t('PRIVACY_SEC6_SHARE_CASES_INTRO')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC6_SHARE_LI1')}</li>
                                <li>{t('PRIVACY_SEC6_SHARE_LI2')}</li>
                            </ol>
                            <p>
                                {t('PRIVACY_SEC6_CONTACT')}{" "}
                                <a href="mailto:privacy@azadea.com">privacy@azadea.com</a>.
        </p>
                        </section>

                        {/* Section 7: Your choices */}
                        <section id="section-7" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC7_TITLE')}</h2>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC7_LI1')}</li>
                                <li>{t('PRIVACY_SEC7_LI2')}</li>
                            </ol>
                        </section>

                        {/* Section 8: Your rights relating to your personal information */}
                        <section id="section-8" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC8_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC8_INTRO')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC8_LI1')}</li>
                                <li>{t('PRIVACY_SEC8_LI2')}</li>
                                <li>{t('PRIVACY_SEC8_LI3')}</li>
                                <li>{t('PRIVACY_SEC8_LI4')}</li>
                                <li>{t('PRIVACY_SEC8_LI5')}</li>
                                <li>{t('PRIVACY_SEC8_LI6')}</li>
                                <li>{t('PRIVACY_SEC8_LI7')}</li>
                                <li>{t('PRIVACY_SEC8_LI8')}</li>
                            </ol>
                            <p>
                                {t('PRIVACY_SEC8_CONTACT')}{" "}
                                <a href="mailto:privacy@azadea.com">privacy@azadea.com</a>.
        </p>
                        </section>

                        {/* Section 9: Security */}
                        <section id="section-9" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC9_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC9_P1')}
                            </p>
                        </section>

                        {/* Section 10: Links */}
                        <section id="section-10" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC10_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC10_P1')}
                            </p>
                        </section>

                        {/* Section 11: Information deletion and retention */}
                        <section id="section-11" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC11_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC11_P1')}
                            </p>
                        </section>

                        {/* Section 12: General */}
                        <section id="section-12" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC12_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC12_P1')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC12_P2')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC12_P3')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC12_P4')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC12_P5')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC12_CONTACT')}{" "}
                                <a href="mailto:privacy@azadea.com">privacy@azadea.com</a>.
        </p>
                        </section>

                        {/* Section 13: Cookies policy */}
                        <section id="section-13" className="mb-8">
                            <h2 className="list-decimal-terms">{t('PRIVACY_SEC13_TITLE')}</h2>
                            <p>
                                {t('PRIVACY_SEC13_P1')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC13_P2')}
                            </p>
                            <ol className="list-decimal-terms">
                                <li>{t('PRIVACY_SEC13_LI1')}</li>
                                <li>{t('PRIVACY_SEC13_LI2')}</li>
                                <li>{t('PRIVACY_SEC13_LI3')}</li>
                                <li>{t('PRIVACY_SEC13_LI4')}</li>
                            </ol>
                            <p>
                                {t('PRIVACY_SEC13_P3')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC13_P4')}
                            </p>
                            <p>
                                {t('PRIVACY_SEC13_P5')}
                            </p>
                        </section>
                    </div>
                </div>
                <Footer />
            </section>
        </>
    )
}
